import { Link } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

export default function ServiceContractLink() {
  return (
    <Link to="#service-contract">
      <T>Service contract</T>
    </Link>
  );
}
